import { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, Zap, ArrowLeft, LayoutGrid, Gamepad2, Users, Gift, CreditCard, BarChart3, Settings2 } from "lucide-react";
import Home from "@/pages/dashboard/Home";
import Zones from "@/pages/dashboard/Zones";
import People from "@/pages/dashboard/People";
import Rewards from "@/pages/dashboard/Rewards";
import Billing from "@/pages/dashboard/Billing";
import Analytics from "@/pages/dashboard/Analytics";
import SettingsTab from "@/pages/dashboard/Settings";

const TABS = [
  { k: "home", l: "Home", i: LayoutGrid }, { k: "zones", l: "Zones", i: Gamepad2 },
  { k: "people", l: "People", i: Users }, { k: "rewards", l: "Rewards", i: Gift },
  { k: "billing", l: "Billing", i: CreditCard }, { k: "analytics", l: "Analytics", i: BarChart3 },
  { k: "settings", l: "Settings", i: Settings2 },
];

export default function ArenaDashboard() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [tab, setTab] = useState("home");

  const refresh = useCallback(() => api.get(`/events/${slug}`).then((r) => setEvent(r.data)).catch(() => navigate("/dashboard")), [slug, navigate]);
  useEffect(() => { refresh(); }, [refresh]);

  if (!event) return <div className="min-h-screen grid place-items-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>;

  const props = { event, slug, refresh };
  return (
    <div className="min-h-screen">
      <header className="glass border-b border-border sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3 min-w-0">
            <button onClick={() => navigate("/dashboard")} className="text-muted-foreground hover:text-foreground"><ArrowLeft className="w-5 h-5" /></button>
            <div className="min-w-0">
              <div className="font-head font-black text-lg truncate flex items-center gap-2"><Zap className="w-4 h-4 text-primary" />{event.name}</div>
            </div>
          </div>
          <span className="text-xs px-2 py-1 rounded-full bg-neon-green/15 text-neon-green font-semibold uppercase">{event.status}</span>
        </div>
        <div className="max-w-6xl mx-auto px-5 flex gap-1 overflow-x-auto no-scrollbar">
          {TABS.map((t) => { const I = t.i; return (
            <button key={t.k} onClick={() => setTab(t.k)} data-testid={`tab-${t.k}`}
              className={`px-4 py-3 text-sm font-semibold whitespace-nowrap border-b-2 flex items-center gap-1.5 ${tab === t.k ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"}`}>
              <I className="w-4 h-4" />{t.l}
            </button>
          ); })}
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-5 py-8">
        {tab === "home" && <Home {...props} />}
        {tab === "zones" && <Zones {...props} />}
        {tab === "people" && <People {...props} />}
        {tab === "rewards" && <Rewards {...props} />}
        {tab === "billing" && <Billing {...props} />}
        {tab === "analytics" && <Analytics {...props} />}
        {tab === "settings" && <SettingsTab {...props} />}
      </div>
    </div>
  );
}
